// extracted by mini-css-extract-plugin
module.exports = {"action-btn":"ActionButton_action-btn__1b0CE","spinner-border":"ActionButton_spinner-border__2Vzdl"};